import {Worker} from "../util";
import moment from "moment";

export default class ObjednavkaDkCtrl {

  dkTypeOptions = [
    {label:"rezervace denní pevné Měsíční Distribuční kapacity", value: "M"},
    {label:"rezervace denní pevné Klouzavé Distribuční kapacity", value: "K"}
  ];

  months = [
    "Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"
  ];

  constructor(OdberneMiestoService, $scope, $q){
    this.$q = $q;
    this.om = $scope.om;
    this.OdberneMiestoService = OdberneMiestoService;
    this.reset();
  }

  reset(){
    this.dkType = "M";
    this.resetMonth();
    this.kdkDoOptions = [];
    this.kdkOd = null;
    this.kdkDo = null;
    this.kdkM3 = 0;
    this.rezPrikon = parseFloat(this.om.rezervovanyPrikonMW);
    this.rkYear = parseFloat(this.om.rkRocnaMW);
    var now = new Date();
    this.datumZahajeniaDistribucie =  new Date(now.getFullYear(), now.getMonth()+1, 1);
    this.save = Worker(this._save);
    this.month = (new Date().getMonth() + 1) % 12;
    this.oneMonth = true;
    this.rok = this.datumZahajeniaDistribucie.getFullYear();
  }

  resetMonth(){
    this.dkMonth = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  }

  updateKdkDoOptions(){
    this.kdkDoOptions = [
      //počet kalendárnych dní mesiaca, v ktorom začne platiť KDK, sa zníži o jeden deň a výsledok pripočíta k dátumu prvého dňa trvania KDK
      moment(this.kdkOd).add((moment(this.kdkOd).daysInMonth() - 1), "days"),
      //posledný kalendárny deň v mesiaci, ktorý nasleduje po mesiaci, v ktorom začne platiť KDK
      moment(this.kdkOd).add(1,"months").endOf("month")
    ];
    this.kdkDo = this.kdkDoOptions[0];
  }

  _save(){
    var objednavkaDk = [];
    if(this.dkType == "M"){
      for(var i=0; i<12; i++){
        if(this.dkMonth[i] > 0){
          objednavkaDk.push({
            om: { id: this.om.id },     
            typ: "M",
            datumZahajeniaDistribucie: moment([this.rok, i, 1]).toDate(),
            datumUkonceniaDistribucie: moment([this.rok, i, 1]).endOf("month").toDate(),
            dkDenM3: this.dkMonth[i]    
          });    
        }
      }
    }else if(this.dkType == "K"){
      objednavkaDk.push({
        om: { id: this.om.id }, 
        typ: "K",
        datumZahajeniaDistribucie: this.kdkOd,
        datumUkonceniaDistribucie: this.kdkDo,
        dkDenM3: this.kdkM3
      });
    }
    return this.OdberneMiestoService.orderDkBatch(objednavkaDk);
  }


}


// WEBPACK FOOTER //
// ./src/RezervovanaKapacita/ObjednavkaDkCtrl.js